var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dialog-spin"}},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner-circle"},[_c('div',{staticClass:"spinner-circle__fill"})])]),_c('p',[_vm._v("POČAKAJTE...")])])
}]

export { render, staticRenderFns }